module.exports = __webpack_public_path__ + "img/employment.f4d79baa.svg";